import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <header className="pt-32 pb-20 md:pt-48 md:pb-32 px-6 md:px-12 max-w-5xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="inline-block mb-6 px-4 py-1.5 rounded-full bg-zinc-100 border border-zinc-200 text-sm font-medium text-zinc-600">
          Protect your digital footprint
        </div>
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-zinc-950 leading-tight mb-8">
          Your apps are collecting data that can be used against you. <br className="hidden md:block"/>
          <span className="text-zinc-500">Most people have no idea how.</span>
        </h1>
        <p className="text-xl md:text-2xl text-zinc-600 mb-12 max-w-3xl mx-auto leading-relaxed">
          We analyze the apps you use and show exactly how your data could impact your money, privacy, and personal life — and what to fix immediately.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#pricing" className="w-full sm:w-auto px-8 py-4 bg-zinc-950 text-white font-medium rounded-lg hover:bg-zinc-800 transition-colors shadow-lg shadow-zinc-900/20 text-lg">
            Get My Data Risk Audit
          </a>
          <a href="#example" className="w-full sm:w-auto px-8 py-4 bg-white text-zinc-900 border border-zinc-200 font-medium rounded-lg hover:bg-zinc-50 transition-colors text-lg">
            See Example Report
          </a>
        </div>
      </motion.div>
    </header>
  );
};

export default Hero;